<p-dialog
  [(visible)]="visible"
  [draggable]="false"
  [resizable]="false"
  [modal]="true"
  [maximizable]="true"
  [closable]="true"
  [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
  [style]="{ width: '90%'}"
  [showHeader]="true"
  [styleClass]="'call-receiving-dialog'"
  [dismissableMask]="true"
  (onHide)="cancelDialog()"
>

  <ng-template pTemplate="header">
    <div class="call-head no-select">
      <div class="head-left">
        <div class="call-id-number">
          <span>{{ call.callId }}</span>
          <span>CA#{{ call.card.id }}</span>
        </div>
        <div class="callid-info ms-5">
          <div class="d-flex-between">
            <img class="icon-queue" src="/assets/theme/w3crm/icons/svgs/queue.svg" alt=""/>
            <span *ngIf="call.callType"
                  class="head-queue-text">{{ call.queue?.valueObject?.name?.value }}
              - {{ call.queue?.valueObject?.description?.value }}</span>
            <small class="badge badge-sm badge-info ms-2"
                   [class.badge-danger]="call.callType=='INBOUND'">{{ 'general.' + call.callType | translate }}</small>
          </div>
          <div>
            <img class="icon-pad" src="/assets/theme/w3crm/icons/svgs/num-pad.svg" alt=""/>
            <span class="head-phone-text"> {{ call.phone }}</span>
          </div>
        </div>
      </div>

      <div class="header-right">
        <div class="patient-related-category">
              <span *ngFor="let category of call?.card?.patient?.category"
                    [class]="category?.valueObject?.class?.value">{{ category?.valueObject?.name?.value }}</span>
        </div>
        <div class="head-between-line"></div>
        <div class="head-call-datetime-text">
          <small class="date">{{ call.callStart | dateFormat }}</small>
          <span>{{ split((call.callStart | dateFormat:true), ' ')[1] }}</span>
        </div>

        <div class="head-call-time" *ngIf="call?.callDuration">
          <img class="icon-call-time" src="/assets/theme/w3crm/icons/svgs/icon-call-time.svg" alt=""/>
          <span>{{ call?.callDuration }}</span>
        </div>
      </div>
    </div>
  </ng-template>
  <ng-template pTemplate="body">
    <div class="d-flex gap-3 call-card p-3">
      <div [class]="isMinimized ? 'col-md-1 col-12' : 'col-md-2 col-12'">
        <div class="card-tab" [class.minimized]="isMinimized" *ngIf="selectRelatedTab!=''">
          <div class="card-tab-list">
            <ul [class.minimize]="isMinimized">
              <li *ngFor="let item of relatedMenuItems | filterBy:'id':selectRelatedTab"
                  [class.active]="selectRelatedTab==item.id"
                  (click)="selectRelatedTab=item.id" role="button"  tabindex="-1">
                <i [innerHtml]="item.svg | safeHtml" class="related-tab-icon"></i>
                <span *ngIf="!isMinimized">{{ item.label | translate }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div
        [class]="isMinimized && !isMinimizedResult ? 'col-md-9' :isMinimized && isMinimizedResult?'col-md-10':!isMinimized && isMinimizedResult?'col-md-9':'col-md-8'">
        <div class="card-body gap-3"
             *ngIf="call.card[selectRelatedTab];else noData">
          <div class="card-item d-grid p-3 active-item">

            <div class="d-flex-between" *ngIf="selectRelatedTab=='instituation'">
              <strong>#{{ call.card[selectRelatedTab]?.id }} {{ call.card[selectRelatedTab]?.signboard }}</strong>
              <a [routerLink]="['/instituation/list']"
                 [queryParams]="{openSidebar: true,instituationId:call.card[selectRelatedTab]?.id}"
                 target="_blank"
                 class="d-flex-between">
                <span class="text-link me-2 mt-1">{{ 'call-receiving-popup.detail' | translate }}</span>
                <img src="/assets/theme/w3crm/icons/svgs/detail.svg" alt=""/>
              </a>
            </div>

            <div class="d-flex-between align-items-end" *ngIf="selectRelatedTab=='instituation'">
              <div class="d-grid ">
                <div class="d-flex align-items-center">
                  <span class="item-name">{{ call.card[selectRelatedTab]?.title }}</span>
                </div>
                <div class="d-flex mt-2">
                  <small class="item-badge-info">ERP <strong>{{ call.card[selectRelatedTab]?.erpCode }}</strong></small>
                  <small class="item-badge-info ms-1">{{ call.card[selectRelatedTab]?.instituationShortCode }}</small>
                </div>
              </div>

              <div class="d-flex-between align-items-end">
                <span *ngFor="let category of call.card[selectRelatedTab]?.category" class="text-uppercase me-2"
                      [class]="category?.valueObject?.class?.value">{{ category?.valueObject?.name?.value }}</span>
                <div class="item-badge-info pe-2 ps-2">
                  <div class="d-flex-between gap-3">
                    <div class="case-history"><span>0</span><small>Yürüyen Vaka</small></div>
                    <div class="case-history text-light"><span>0</span><small>Biten Vaka</small></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex-between" *ngIf="selectRelatedTab=='patient'">
              <strong>#{{ call.card[selectRelatedTab]?.id }}</strong>
              <a [routerLink]="['/definition/patient/list']"
                 [queryParams]="{openSidebar: true,patientId:call.card[selectRelatedTab]?.id}"
                 target="_blank"
                 class="d-flex-between">
                <span class="text-link me-2 mt-1">{{ 'call-receiving-popup.detail' | translate }}</span>
                <img src="/assets/theme/w3crm/icons/svgs/detail.svg" alt=""/>
              </a>
            </div>

            <div class="d-flex-between"
                 *ngIf="selectRelatedTab=='caseOngoingPatientInformation' || selectRelatedTab=='caseEndedPatientInformation'">
              <strong>#V-{{ call.card[selectRelatedTab]?.cases?.caseNo }}
                | {{ call.card[selectRelatedTab]?.cases?.caseType?.valueObject?.name?.value }}</strong>
              <a [routerLink]="['/case/'+call.card[selectRelatedTab]?.cases?.id]" [queryParams]="{openSidebar: true}"
                 target="_blank"
                 class="d-flex-between">
                <span class="text-link me-2 mt-1">{{ 'call-receiving-popup.detail' | translate }}</span>
                <img src="/assets/theme/w3crm/icons/svgs/detail.svg" alt=""/>
              </a>
            </div>


            <div class="d-flex-between align-items-end" *ngIf="selectRelatedTab=='patient'">
              <div class="d-grid ">
                <div class="d-flex align-items-center">
                  <span><img src="/assets/theme/w3crm/icons/svgs/verify.svg" alt=""/></span>
                  <span
                    class="item-name">{{ call.card[selectRelatedTab]?.firstName }} {{ call.card[selectRelatedTab]?.lastName }}</span>
                </div>
                <div class="d-flex mt-2">
                  <small
                    class="item-badge-info">{{ 'gender.' + call.card[selectRelatedTab]?.gender.toLowerCase() | translate }}</small>
                  <small class="item-badge-info ms-1">{{ call.card[selectRelatedTab].birthDate | dateFormat }}</small>
                </div>
              </div>

              <div class="d-flex-between align-items-end">
                <span *ngFor="let category of call.card[selectRelatedTab]?.category" class="text-uppercase me-2"
                      [class]="category?.valueObject?.class?.value">{{ category?.valueObject?.name?.value }}</span>
                <div class="item-badge-info pe-2 ps-2">
                  <div class="d-flex-between gap-3">
                    <div class="case-history"><span>0</span><small>Yürüyen Vaka</small></div>
                    <div class="case-history text-light"><span>0</span><small>Biten Vaka</small></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex-between align-items-end"
                 *ngIf="selectRelatedTab=='caseOngoingPatientInformation' || selectRelatedTab=='caseEndedPatientInformation'">
              <div class="d-grid ">
                <div class="d-flex align-items-center">
                  <span><img src="/assets/theme/w3crm/icons/svgs/verify.svg" alt=""/></span>
                  <span
                    class="item-name">{{ call.card[selectRelatedTab]?.firstName }} {{ call.card[selectRelatedTab]?.lastName }}</span>
                </div>
                <div class="d-flex mt-2">
                  <small class="item-badge-info ms-1"
                         *ngFor="let diagnose of call.card[selectRelatedTab]?.cases?.caseInformations?.diagnoses">{{ diagnose.icdCode.name }}</small>
                </div>
              </div>

              <div class="d-flex-between align-items-end">
                <span *ngFor="let category of call.card[selectRelatedTab]?.patient?.category"
                      class="text-uppercase me-2"
                      [class]="category?.valueObject?.class?.value">{{ category?.valueObject?.name?.value }}</span>
                <div class="item-badge-info pe-2 ps-2">
                  <div class="d-flex-between gap-3">
                    <div class="case-history">
                      <span>{{ (call.card[selectRelatedTab]?.cases?.createdAt | dateFormat:true).split(" ")[1].substring(0, 5) }}</span><small
                      class="text-break">{{ call.card[selectRelatedTab]?.cases?.createdAt | dateFormat }}</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ng-template #noData>
          <div class="card-body gap-3 text-light">
            {{ 'general.empty-data' | translate }}
          </div>
        </ng-template>
      </div>

      <div [class]="isMinimizedResult ? 'col-md-1' : 'col-md-2'" class="pe-4">
        <div class="card-tab  mb-3" *ngIf="call?.card?.status">
          <div class="card-tab-list result" (ngInit)="setResultCodes()">
            <ul [class.minimize]="isMinimizedResult" id="others">
              <li
                *ngFor="let item of (resultCodes | filterBy:'id':call?.card?.status?.valueObject?.id?.value) | sort:'sort':'asc';let i = index;">
                <i [innerHtml]="item.icon | safeHtml"></i>
                <span *ngIf="!isMinimizedResult"
                      class="text-lowercase text-capitalize">{{ item.name | translate }}</span>
              </li>
            </ul>
          </div>
        </div>

        <div class="card-tab" [class.minimized]="isMinimizedResult">
          <div class="card-tab-head note d-flex-between align-items-center">
            <div class="title" [class.d-center]="isMinimizedResult">

              <img src="/assets/theme/w3crm/icons/svgs/note.svg" alt=""/>
              <strong class="ms-2"
                      *ngIf="!isMinimizedResult"> {{ 'call-receiving-popup.call-note'  | translate }}</strong>

            </div>
          </div>
          <textarea class="form-control card-body border-0 mt-2" placeholder="Notunuz"
                    readonly>{{ call.card?.note }}</textarea>


        </div>
      </div>

    </div>
  </ng-template>
</p-dialog>
<app-patient-create #showPatient></app-patient-create>
